module.exports = "../fonts/telegram_authorize.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telegram_authorize.svg
// module id = 217
// module chunks = 0